define('modules/lp_info/views/navigation',['require','exports','module','base/view','ldsh!../templates/navigation'],function(require, exports, module) {
  "use strict";

  var View = require("base/view");

  module.exports = View.extend({
    template: require("ldsh!../templates/navigation"),
    triggers: {
      "click .js-datepicker-button": "datepicker:toggle"
    }
  });

});

